var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGoogle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6711 8.36727H17.9998V8.33268H10.4998V11.666H15.2094C14.5223 13.6064 12.6761 14.9993 10.4998 14.9993C7.73859 14.9993 5.49984 12.7606 5.49984 9.99935C5.49984 7.2381 7.73859 4.99935 10.4998 4.99935C11.7744 4.99935 12.934 5.48018 13.8169 6.2656L16.174 3.90852C14.6857 2.52143 12.6948 1.66602 10.4998 1.66602C5.89775 1.66602 2.1665 5.39727 2.1665 9.99935C2.1665 14.6014 5.89775 18.3327 10.4998 18.3327C15.1019 18.3327 18.8332 14.6014 18.8332 9.99935C18.8332 9.4406 18.7757 8.89518 18.6711 8.36727Z",
    fill: "#FFC107"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.12744 6.1206L5.86536 8.12852C6.60619 6.29435 8.40036 4.99935 10.4999 4.99935C11.7745 4.99935 12.9341 5.48018 13.817 6.2656L16.1741 3.90852C14.6858 2.52143 12.6949 1.66602 10.4999 1.66602C7.29911 1.66602 4.52327 3.4731 3.12744 6.1206Z",
    fill: "#FF3D00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4998 18.3336C12.6523 18.3336 14.6081 17.5099 16.0869 16.1703L13.5077 13.9878C12.6429 14.6454 11.5862 15.0011 10.4998 15.0003C8.3323 15.0003 6.49189 13.6182 5.79855 11.6895L3.08105 13.7832C4.46022 16.4819 7.26105 18.3336 10.4998 18.3336Z",
    fill: "#4CAF50"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6713 8.36857H18V8.33398H10.5V11.6673H15.2096C14.8809 12.5908 14.2889 13.3978 13.5067 13.9886L13.5079 13.9877L16.0871 16.1702C15.9046 16.3361 18.8333 14.1673 18.8333 10.0007C18.8333 9.4419 18.7758 8.89648 18.6713 8.36857Z",
    fill: "#1976D2"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.222fbd2dac4059f01c8feb9da7292797.svg";
export { ForwardRef as ReactComponent };